module.exports = __webpack_public_path__ + "img/homebg.03565a29.png";